import Swiper from "swiper/bundle";
const [ w, d, mq ] = [ window, document, window.matchMedia('(max-width: 900px)') ]

const init = () => {
  let Mv = document.querySelector('.mainvisual');
  window.addEventListener('load', function() {
    Mv.classList.add('loaded');
  });

  const mvSlide = new Swiper('.mv_slide[data-plugin="mainSlider"]',{
    direction: 'vertical',
    loop: true,
    effect: 'fade',
    speed: 1200,
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true,
    },
    autoplay:{
      delay: 4000,
      disableOnInteraction: false,
      waitForTransition: false
    },
  });

  $(w).on('scroll',function(){
    let t = $(this).scrollTop();
    let mvH = $('.mainvisual').height();
    if(t > mvH){
      $('header').addClass('scroll');
    } else {
      $('header').removeClass('scroll');
    }
  });
}

export default function HOME () {
  d.addEventListener('DOMContentLoaded', init );
}